import { useEffect, useState } from 'react';
import operationsDashboard from '../assets/Operations Dashboard.png';
import './Hero.css';

export default function Hero() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="hero dot-grid" aria-label="TaxiOps hero">
      {/* Background glow orbs */}
      <div className="hero__orb hero__orb--1" aria-hidden="true" />
      <div className="hero__orb hero__orb--2" aria-hidden="true" />
      <div className="hero__orb hero__orb--3" aria-hidden="true" />

      <div className="container hero__container">
        {/* Top badges */}
        <div className={`hero__badges ${loaded ? 'hero__badges--visible' : ''}`}>
          <span className="badge badge--yellow">
            <span className="hero__pulse" aria-hidden="true" />
            Purpose-Built Taxi Operations Platform
          </span>
          <span className="badge badge--gray">An Old Alex Hub Company</span>
        </div>

        {/* Headline */}
        <h1 className={`hero__headline ${loaded ? 'hero__headline--visible' : ''}`}>
          Classic Dispatch.<br />
          <span className="gradient-text">Modern Operations.</span><br />
          AI-Powered Intelligence.
        </h1>

        {/* Sub-headline */}
        <p className={`hero__sub ${loaded ? 'hero__sub--visible' : ''}`}>
          TaxiOps is a connected operating system for professional taxi and private hire
          fleets: live dispatch, driver mobile apps, digital metering, fleet visibility,
          receipts, reporting, EnrollMe compliance workflows, and operations intelligence
          built from real transportation work.
        </p>

        {/* Tags */}
        <div className={`hero__tags ${loaded ? 'hero__tags--visible' : ''}`}>
          <span className="hero__tag">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <path d="M7 1.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11zM0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z" fill="currentColor" opacity=".5"/>
              <path d="M7 4v3l2 2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
            </svg>
            Taxi &amp; Private Hire Operations
          </span>
          <span className="hero__tag hero__tag--ai">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <path d="M7 1l1.5 3.5L12 6 8.5 7.5 7 11 5.5 7.5 2 6l3.5-1.5L7 1z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/>
            </svg>
            Demand &amp; Dispatch Intelligence
          </span>
          <span className="hero__tag">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <path d="M7 1.5C4 1.5 1.5 4 1.5 7S4 12.5 7 12.5 12.5 10 12.5 7 10 1.5 7 1.5z" stroke="currentColor" strokeWidth="1.3"/>
              <path d="M7 5v4M5 7h4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
            </svg>
            Built for Real Operators
          </span>
        </div>

        {/* CTAs */}
        <div className={`hero__ctas ${loaded ? 'hero__ctas--visible' : ''}`}>
          <a
            href="mailto:info@oldalexhub.com?subject=TaxiOps Future Availability Inquiry"
            className="btn btn--primary hero__cta-primary"
          >
            Express Future Interest
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
          <a
            href="#platform"
            className="btn btn--outline hero__cta-secondary"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('platform')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Explore the Platform
          </a>
        </div>

        {/* Stats row */}
        <div className={`hero__stats ${loaded ? 'hero__stats--visible' : ''}`}>
          <div className="hero__stat">
            <span className="hero__stat-value">Live</span>
            <span className="hero__stat-label">Dispatch Map</span>
          </div>
          <div className="hero__stat-divider" aria-hidden="true" />
          <div className="hero__stat">
            <span className="hero__stat-value">Android + iOS</span>
            <span className="hero__stat-label">Driver Apps</span>
          </div>
          <div className="hero__stat-divider" aria-hidden="true" />
          <div className="hero__stat">
            <span className="hero__stat-value">25+</span>
            <span className="hero__stat-label">Platform Capabilities</span>
          </div>
          <div className="hero__stat-divider" aria-hidden="true" />
          <div className="hero__stat">
            <span className="hero__stat-value gradient-text">EnrollMe</span>
            <span className="hero__stat-label">Compliance Tower</span>
          </div>
        </div>

        {/* Dashboard placeholder */}
        <div className={`hero__dashboard-frame ${loaded ? 'hero__dashboard-frame--visible' : ''}`}>
          <div className="hero__frame-bar" aria-hidden="true">
            <span className="hero__frame-dot hero__frame-dot--red" />
            <span className="hero__frame-dot hero__frame-dot--yellow" />
            <span className="hero__frame-dot hero__frame-dot--green" />
            <span className="hero__frame-label">TaxiOps Operations Dashboard</span>
          </div>
          <img
            src={operationsDashboard}
            alt="TaxiOps Operations Dashboard"
            className="hero__dashboard-img"
          />
        </div>
      </div>
    </section>
  );
}
